import Config from "../config";
import axios from 'axios';
import Global from './global';

axios.defaults.baseURL = Config.host + 'api/';
axios.defaults.headers = {'SID': ''};

let app = null;

function emptySID() {
    return !axios.defaults.headers.SID;
}

function setSID(sid) {
    Global.setItem('sid', sid);
    axios.defaults.headers.SID = sid;
}

function post(url, params) {
    if (app == null)
        app = window.VueApp;

    if (emptySID()) {
        setSID(Global.getItem('sid'));
    }

    return new Promise((resolve, reject) => {
        axios.post(url, params).then((rs) => {
            if (rs.status == 200) {
                resolve(rs.data);
            } else {
                reject('网络错误！');
            }
        }).catch((error) => {
            reject(error);
        });
    });
}

export default {
    setSID,

    post,
}
